var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.958 12a1.458 1.458 0 11-2.916 0 1.458 1.458 0 012.916 0zm5 0a1.458 1.458 0 11-2.916 0 1.458 1.458 0 012.916 0zm-5-5A1.458 1.458 0 11.042 7a1.458 1.458 0 012.916 0zm5 0a1.458 1.458 0 11-2.916 0 1.458 1.458 0 012.916 0zm-5-5A1.458 1.458 0 11.042 2a1.458 1.458 0 012.916 0zm5 0a1.458 1.458 0 11-2.916 0 1.458 1.458 0 012.916 0z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDots);
export default __webpack_public_path__ + "static/media/drag-dots.97da71f71fbb23d8b0081bba8bebbb79.svg";
export { ForwardRef as ReactComponent };